import { render } from "./tabSlider.vue?vue&type=template&id=6afbda83&scoped=true"
import script from "./tabSlider.vue?vue&type=script&lang=js"
export * from "./tabSlider.vue?vue&type=script&lang=js"

import "./tabSlider.vue?vue&type=style&index=0&id=6afbda83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afbda83"]])

export default __exports__